export default __webpack_public_path__ + "static/media/kitchen3-after2-768w.8875f4ed.webp";